// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/article-hero-banner/article-hero-banner.component.scss
// module id = 657
// module chunks = 0